import AWS
    from 'aws-sdk'
import {
    CognitoUser,
    CognitoUserPool,
    AuthenticationDetails, ISignUpResult, CognitoUserSession, NodeCallback,
} from 'amazon-cognito-identity-js';
import Authorization from "./auth_base"

/**
 *
 */
export default class Cognito implements Authorization {

    /**
     *
     */
    credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: String(process.env.VUE_APP_COGNITO_IdentityPoolId),
    });

    userPool = new CognitoUserPool({
        UserPoolId: String(process.env.VUE_APP_COGNITO_UserPoolId),
        ClientId: String(process.env.VUE_APP_COGNITO_ClientId),
    });

    constructor() {
        AWS.config.region = String(process.env.VUE_APP_AWS_Region); // リージョン
    }

    /**
     * @param username
     */
    getCognitoUser(username: string){
        const cognitoUser = new CognitoUser({
            Username: username,
            Pool: this.userPool
        });
        cognitoUser.getSession(function (data: any) {
            //console.log(data);
        });
        return cognitoUser;
    }

    /**
     *
     * @param username
     */
    resendConfirmUrl(username: string) {
        this.getCognitoUser(username).resendConfirmationCode(function(err, result) {
            if (err) {
                alert(err.message || JSON.stringify(err));
                return;
            }
            //console.log('call result: ' + result);
        });
    }


    /**
     * @param username
     * @param password
     * @return Promise
     */
    signUp(username: string, password: string): Promise<ISignUpResult> {
        return new Promise((resolve, reject) => {
            this.userPool.signUp(username, password, [], [], function (
                err,
                result
            ) {
                if (err) {
//                    alert(err.message || JSON.stringify(err));
                    reject(err);
                    return;
                }
                resolve(result);
                //var cognitoUser = result.user;
                ////console.log('user name is ' + cognitoUser.getUsername());
            });
        });
    }

    /**
     * @param username
     * @param password
     */
    signIn(username: string, password: string): Promise<CognitoUserSession> {
        const authenticationDetails = new AuthenticationDetails(
            {
                Username: username,
                Password: password,
            }
        );

        //console.log(this.userPool)

        const cognitoUser = new CognitoUser({
            Username: username,
            Pool: this.userPool,
        });

        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: result => {
                    //let accessToken = result.getAccessToken().getJwtToken();
                    //const credentials = AWS.config.credentials;
                    this.credentials.refresh(error => {
//                            new AWS.CognitoIdentityCredentials().refresh((error) => {
                        if (error) {
                            //console.error(error);
                            reject(error);
                            return;
                        }
                        //console.log('Successfully logged!');
                        //console.log(result);
                        //console.log(result.getAccessToken());
                        //resolve(result.getAccessToken().getJwtToken());
                        resolve(result);
                    });
                },
                onFailure: function (err) {
                    reject(err);
                },
            });
        });
    }

    /**
     *
     * @param username
     * @param code
     */
    confirm(username: string, code: string): Promise<ISignUpResult> {
        const cognitoUser = new CognitoUser({
            Username: username,
            Pool: this.userPool
        });
        return new Promise((resolve, reject) => {
            cognitoUser.confirmRegistration(code, true, function (err, result) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result);
            });
        });
    }

    /**
     * @param username
     * @param oldPassword
     * @param newPassword
     */
    passwordChange(username: string, oldPassword: string, newPassword: string): Promise<any> {
        const cognitoUser = this.getCognitoUser(username);
        return new Promise((resolve, reject) => {
            cognitoUser.changePassword(oldPassword, newPassword,
                function (err, result) {
                    if (err) {
                        //console.log(err);
                        reject(err.message || JSON.stringify(err));
                        return;
                    }
                    resolve(result);
                });
        });
    }

    /**
     * @param username
     * @param clientId
     * @param confirmationCode
     */
    getConfirmUrl(username: string, clientId: string, confirmationCode: string): string {
        return 'https://'
            + String(process.env.VUE_APP_COGNITO_CognitoDomain)
            + '.auth'
            + '.' + String(process.env.VUE_APP_AWS_Region)
            + '.amazoncognito.com/confirmUser?'
            + 'client_id=' + clientId + '&'
            + 'user_name=' + username + '&'
            + 'confirmation_code=' + confirmationCode
    }

    /**
     * @param cognitoUser
     */
    forgotPassword(cognitoUser: CognitoUser): Promise<any> {
        return new Promise((resolve, reject) =>{
            cognitoUser.forgotPassword({
                onSuccess: result => {
                    // console.log('call result: ' + result);
                    resolve(result);
                },
                onFailure: err => {
                    reject(err.message || JSON.stringify(err));
                    return;
                }
            })
        });
    }

    /**
     * @param cognitoUser
     * @param code
     * @param newPassword
     */
    confirmForgotPassword(cognitoUser: CognitoUser, code: string, newPassword: string): Promise<any> {
        return new Promise((resolve, reject) => {
            cognitoUser.confirmPassword(code, newPassword, {
                onSuccess: function () {
                    resolve();
                },
                onFailure: function(err) {
                    reject(err.message || JSON.stringify(err));
                    return;
                },
            });
        });
    }
}